import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import AdminLayout from "@/components/AdminLayout";
import { LayoutDashboard, BookOpen, Users, Wallet, Undo2, FileText, BarChart3, Lock } from "lucide-react";

const TABS = [
    { to: "/admin/finance", end: true, label: "Genel Bakış", icon: LayoutDashboard, testid: "fin-tab-dashboard" },
    { to: "/admin/finance/ledger", label: "Yevmiye Defteri", icon: BookOpen, testid: "fin-tab-ledger" },
    { to: "/admin/finance/parties", label: "Cari Hesaplar", icon: Users, testid: "fin-tab-parties" },
    { to: "/admin/finance/cash", label: "Kasa & Banka", icon: Wallet, testid: "fin-tab-cash" },
    { to: "/admin/finance/refunds", label: "İade Talepleri", icon: Undo2, testid: "fin-tab-refunds" },
    { to: "/admin/finance/invoices", label: "Faturalar", icon: FileText, testid: "fin-tab-invoices" },
    { to: "/admin/finance/reports", label: "Raporlar", icon: BarChart3, testid: "fin-tab-reports" },
    { to: "/admin/finance/period-close", label: "Dönem Kapanış", icon: Lock, testid: "fin-tab-period" },
];

export default function FinanceShell({ title, action, children }) {
    return (
        <AdminLayout title={title || "Muhasebe & Finans"} action={action}>
            <div className="flex gap-1 mb-5 overflow-x-auto pb-1 border-b border-slate-200 dark:border-slate-800" data-testid="finance-tabs">
                {TABS.map((t) => (
                    <NavLink
                        key={t.to}
                        to={t.to}
                        end={t.end}
                        data-testid={t.testid}
                        className={({ isActive }) =>
                            `inline-flex items-center gap-2 px-3.5 py-2 text-sm font-semibold rounded-t-lg transition whitespace-nowrap ${
                                isActive
                                    ? "bg-sky-50 dark:bg-sky-950/40 text-sky-700 dark:text-sky-300 border-b-2 border-sky-600"
                                    : "text-slate-500 hover:text-slate-700 dark:hover:text-slate-200 border-b-2 border-transparent"
                            }`
                        }
                    >
                        <t.icon className="h-4 w-4" />
                        {t.label}
                    </NavLink>
                ))}
            </div>
            {children}
        </AdminLayout>
    );
}
